
import React from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Link } from "react-router-dom";

const NewsletterSection: React.FC = () => {
  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-gray-900">Stay updated with AI Nexus</h2>
        <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
          Subscribe to our newsletter to receive the latest articles and updates directly in your inbox.
        </p>
        <div className="mt-8 sm:flex sm:justify-center">
          <div className="sm:flex-1 sm:max-w-md">
            <form className="sm:flex">
              <Input
                type="email"
                placeholder="Enter your email"
                className="w-full px-5 py-3 focus:ring-ai-indigo focus:border-ai-indigo"
              />
              <div className="mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                <Button className="w-full bg-ai-indigo hover:bg-ai-indigo/90">
                  Subscribe
                </Button>
              </div>
            </form>
            <p className="mt-3 text-sm text-gray-500">
              We care about your data. Read our{' '}
              <Link to="/privacy" className="font-medium text-ai-indigo hover:underline">
                Privacy Policy
              </Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
